// Datos del paso a Barberfy. Todo lo que dicen la franja de la cabecera,
// la página /barberfy y el aviso de «Mis citas» sale de aquí.

export const URL_BARBERFY = 'https://barberfy.com/es-es/b/barber-mujica';
export const URL_BARBERFY_LOGIN = 'https://barberfy.com/es-es/iniciar-sesion';
export const URL_BARBERFY_REGISTRO = 'https://barberfy.com/es-es/registro';

// Ayuda por WhatsApp para problemas con la cuenta.
export const WHATSAPP_AYUDA = '613 26 98 89';
export const URL_WHATSAPP_AYUDA =
  'https://wa.me/34613269889?text=' +
  encodeURIComponent('Hola, tengo un problema con mi cuenta para reservar en Barberfy.');

// Miércoles 4 de noviembre de 2026, a las 00:00 en España.
export const FECHA_CAMBIO = new Date('2026-11-04T00:00:00+01:00');
export const DIA_CAMBIO = 'miércoles 4 de noviembre';

export const yaEstamosEnBarberfy = () => new Date() >= FECHA_CAMBIO;
